module.exports = "../../app/cells/components/ranking/featured_section_cell.rb";